import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { toast } from "sonner";
import { Btn } from "@/components/erp/ui";

const err = (e) => toast.error(e?.response?.data?.detail || "Gagal");

export const deleteQuotation = async (q, onDone) => {
  const reason = (window.prompt(`Alasan menghapus quotation ${q.code} (wajib):`) || "").trim();
  if (reason.length < 5) { toast.error("Alasan penghapusan wajib diisi (min. 5 huruf)"); return; }
  if (!window.confirm(`Hapus quotation ${q.code}? Akan dipindah ke Arsip.`)) return;
  try { await api.delete(`/quotations/${q.id}`, { data: { reason } }); toast.success("Quotation dipindah ke arsip"); onDone(); } catch (e) { err(e); }
};

export const QuotationArchive = ({ onRestored }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/quotations-archive").then(({ data }) => setD(data)).catch(err);
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const restore = async (r) => { if (!window.confirm(`Pulihkan ${r.code}?`)) return; try { await api.post(`/quotations-archive/${r.id}/restore`); toast.success("Dipulihkan"); load(); onRestored(); } catch (e) { err(e); } };
  const empty = async () => { if (!window.confirm("Kosongkan arsip? Semua quotation di arsip terhapus permanen.") || !window.confirm("Konfirmasi sekali lagi: hapus permanen?")) return; try { const { data } = await api.delete("/quotations-archive"); toast.success(`${data.deleted} quotation dihapus permanen`); load(); } catch (e) { err(e); } };
  return (
    <div className="space-y-2" data-testid="quotation-archive">
      <div className="flex items-center gap-2"><span className="text-xs text-slate-500 flex-1">{d.rows.length} quotation terhapus</span>{d.can_empty && d.rows.length > 0 && <Btn variant="ghost" data-testid="quotation-archive-empty" onClick={empty}>Kosongkan arsip</Btn>}</div>
      <div className="max-h-[60vh] overflow-y-auto divide-y divide-slate-100">{d.rows.map((r) => (
        <div key={r.id} className="py-2 text-sm flex flex-wrap items-center gap-2" data-testid={`quotation-archive-row-${r.id}`}>
          <div className="flex-1 min-w-[220px]"><b className="font-mono text-xs">{r.code}</b> · {r.customer_name} · {formatIDR(r.quote?.total || 0)}
            <div className="text-[11px] text-slate-500">Dihapus {r.deleted_by} · {r.deleted_at ? new Date(r.deleted_at).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" }) : ""} · alasan: {r.deleted_reason}</div></div>
          {d.can_empty && <Btn variant="ghost" data-testid={`quotation-restore-${r.id}`} onClick={() => restore(r)}>Pulihkan</Btn>}
        </div>))}
        {!d.rows.length && <p className="text-xs text-slate-400 py-2">Arsip kosong.</p>}</div>
    </div>
  );
};
